import {
  ACTIVE_STATUS,
  APPROVED_STATUS,
  ARCHIVED_STATUS,
  DECLINED_STATUS,
  DRAFT_STATUS,
  MODERATING_STATUS,
  PAUSED_STATUS,
} from '@esentai/core/features/campaigns/consts/statuses';
import PropTypes from 'prop-types';
import React from 'react';

import DotIndicator from '@/components/DotIndicator';

const dotIncicatorStatuses = {
  [ACTIVE_STATUS]: 'enabled',
  [ARCHIVED_STATUS]: 'disabled',
  [APPROVED_STATUS]: 'pending',
  [DECLINED_STATUS]: 'errorred',
  [DRAFT_STATUS]: 'blocked',
  [MODERATING_STATUS]: 'pending',
  [PAUSED_STATUS]: 'disabled',
};

const StatusIndicator = ({ status }) => (
  <DotIndicator status={dotIncicatorStatuses[status]} />
);

StatusIndicator.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusIndicator;
